import React from "react";
import { ControlLabel, Button, Alert } from "react-bootstrap";
import ajax from "./../../lib/ajax.js";
import context from "./../../lib/context.js";

export default class AnnouncementListItem extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        let self = this;
        let vm = this.props.vm; 
        let isSticky = this.props.noLabel;
        let isNew = this.props.noLabel;
        let headerUrl = context.root() + '/app/add-announcement/' + vm.announcementId;

        if (vm.sticky) {
            isSticky = this.props.yesLabel;
        }

        if (vm.newIcon) {
            isNew = this.props.yesLabel;
        }

        return (
            <tr>
                <td>{vm.announcementId}</td>
                <td>
                    <a href={headerUrl}>{vm.header}</a>
                </td>
                <td>{isSticky}</td>
                <td>{vm.linkType}</td>
                <td>{vm.linkId}</td>
                <td>{vm.groupBy}</td>
                <td>{vm.formattedStartDate}</td>
                <td>{vm.formattedEndDate}</td>
                <td>{isNew}</td>
                <td>{vm.formattedCreationDate}</td>
                <td>{vm.creationOperator}</td>
                <td>{vm.formattedModifyDate}</td>
                <td>{vm.modifyOperator}</td>
            </tr>
        );
    }
}